import {
    fork,
    put,
    all,
    call,
    takeLatest,
    delay,
  } from "redux-saga/effects";
  
  import {
    postFeatureConfigurationSuccessful,
    postFeatureConfigurationFailure,
    clearAllFeatureConfigurationMessagesSuccessful,
  } from "./featureConfigurationSlice";
  
  import {
    postFeatureConfiguration as postFeatureConfigurationApi,
  } from "../../helpers/auth_aws_helper";
  
  function* postFeatureConfiguration( {payload: featureConfigurationPayload} ) {
    try {
      console.log("about to call *postFeatureConfiguration() with ", featureConfigurationPayload);
      const response = yield call(postFeatureConfigurationApi, featureConfigurationPayload);
      console.log("*postFeatureConfigurationApi() response: ", response);
  
      if (response && response.status === 200) {
        // Handle case where response.data might be undefined
        const responseData = response.data || response || "Feature configuration completed successfully";
        yield put(postFeatureConfigurationSuccessful(responseData));
      } else {
        const errorMessage = response?.data || response || "Unknown error occurred";
        yield put(postFeatureConfigurationFailure({ message: errorMessage }));
      }
    } catch (error) {
      console.error("Feature configuration error:", error);
      
      if (error.response) {
        const errorMessage = error.response?.data || `Error Code: ${error.response?.status}`;
        yield put(
          postFeatureConfigurationFailure({
            message: errorMessage,
          })
        );
      } else if (error.request) {
        yield put(postFeatureConfigurationFailure({ 
          message: "No response received from server. Please try again after a while. If the issue persists, please contact Support at support.cloudcatcher@cloudnovatech.com" 
        }));
      } else {
        yield put(postFeatureConfigurationFailure({ 
          message: error?.message || "An unexpected error occurred. Please try again after a while. If the issue persists, please contact Support at support.cloudcatcher@cloudnovatech.com" 
        }));
      }
    }
  }
  
  function* clearAllFeatureConfigurationMessages() {
    console.log("Saga: clear All FeatureConfiguration Messages");
    yield put(clearAllFeatureConfigurationMessagesSuccessful());
  }
  
  export function* watchFeatureConfiguration() {
    yield takeLatest("featureConfiguration/postFeatureConfiguration", postFeatureConfiguration);
    yield takeLatest("featureConfiguration/clearAllFeatureConfigurationMessages", clearAllFeatureConfigurationMessages);
  }
  
  export function* watchFeatureConfigurationSaga() {
    yield all([fork(watchFeatureConfiguration)]);
  }
  
  export default watchFeatureConfigurationSaga;